/**
 * @generated SignedSource<<df4fb7bcdaff37db1e37ce5049d0872e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GameList_provider_games$data = {
  readonly games: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"GameFeed_games">;
      };
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "GameList_provider_games";
};
export type GameList_provider_games$key = {
  readonly " $data"?: GameList_provider_games$data;
  readonly " $fragmentSpreads": FragmentRefs<"GameList_provider_games">;
};

import ProviderProviderIndexGameListPaginationQuery_graphql from './ProviderProviderIndexGameListPaginationQuery.graphql';
const node: ReaderFragment = (function(){
var v0 = [
  "games"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 5,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "youth"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": ProviderProviderIndexGameListPaginationQuery_graphql,
      "identifierField": "id"
    }
  },
  "name": "GameList_provider_games",
  "selections": [
    {
      "alias": "games",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "ASC",
            "field": "START_TIME"
          }
        },
        {
          "kind": "Literal",
          "name": "times",
          "value": [
            "UPCOMING"
          ]
        },
        {
          "kind": "Variable",
          "name": "youth",
          "variableName": "youth"
        }
      ],
      "concreteType": "GameConnection",
      "kind": "LinkedField",
      "name": "__GameList_provider_games_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GameEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Game",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "GameFeed_games"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Provider",
  "abstractKey": null
};
})();

(node as any).hash = "1d2b4c9582050ef4a2ab2d5cc3b29548";

export default node;
